export const GET_COMPANY_PURCHASED_CANDIDATES_REQUEST = 'GET_COMPANY_PURCHASED_CANDIDATES_REQUEST';
export const GET_COMPANY_PURCHASED_CANDIDATES_SUCCESS = 'GET_COMPANY_PURCHASED_CANDIDATES_SUCCESS';
export const GET_COMPANY_PURCHASED_CANDIDATES_FAILURE = 'GET_COMPANY_PURCHASED_CANDIDATES_FAILURE';

export const RESET_PURCHASED_LIST_SUCCESS = 'RESET_PURCHASED_LIST_SUCCESS';
